import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Logout({ setAuth }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authToken"); // Remove the token from localStorage
    setAuth(false); // Clear authentication state
    navigate("/login"); // Redirect to the login page
  };

  React.useEffect(() => {
    handleLogout();
  }, []);

  return null; // No UI needed for logout
}